/**
 * Bot row detection + subtle scoreboard marker.
 *
 * Server-side bots keep the `__dummy_<n>__` session-id convention
 * (server/src/rooms/ArenaRoom.ts spawnDummy) even though arena bots now carry
 * human-like display names. The id is therefore the one reliable signal a
 * client has that a row is a bot — the name no longer says so.
 *
 * The marker is deliberately quiet ("·AI", rendered dimmed by the HUD): the
 * product goal is a lobby that feels populated, with honest-but-subtle bot
 * disclosure, not a shouting BOT badge.
 */

export const BOT_ID_PREFIX = "__dummy_";

export function isBotPlayerId(id: string): boolean {
  return id.startsWith(BOT_ID_PREFIX);
}

/** "·AI" for bot rows, "" for humans. Plain text — caller owns the styling. */
export function botMarker(id: string): string {
  return isBotPlayerId(id) ? "·AI" : "";
}
